import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import {
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloOfflineException3onq1f2zlyouj as ApolloOfflineException,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { emitAllc6188g3y1sqz as emitAll } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
import { retryWhenf2aqzvtrvxoo as retryWhen } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { waitForNetworkf4ygunw90mrf as waitForNetwork } from '../network/NetworkMonitor.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import {
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { coerceAtMostfyc3emgaderp as coerceAtMost } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delayvyed5wvki0ic as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_defaultRetryStrategy() {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return defaultRetryStrategy;
}
var defaultRetryStrategy;
var RetryStrategyClass;
function RetryStrategy() {
  if (RetryStrategyClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RetryStrategy', VOID, VOID, VOID, [1]);
    RetryStrategyClass = $;
  }
  return RetryStrategyClass;
}
var RetryContextClass;
function RetryContext() {
  if (RetryContextClass === VOID) {
    class $ {
      constructor(networkMonitor, request) {
        this.y62_1 = networkMonitor;
        this.z62_1 = request;
        this.a63_1 = 0;
      }
      c63() {
        var tmp = this.b63_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('_response');
        }
      }
      t5g() {
        return this.c63();
      }
      d63() {
        this.a63_1 = 0;
      }
      e63() {
        return this.a63_1;
      }
    }
    initMetadataForClass($, 'RetryContext');
    RetryContextClass = $;
  }
  return RetryContextClass;
}
function isRecoverable(_this__u8e3s4) {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  var tmp;
  if (_this__u8e3s4 instanceof ApolloNetworkException()) {
    tmp = true;
  } else {
    if (_this__u8e3s4 instanceof ApolloWebSocketClosedException()) {
      tmp = true;
    } else {
      tmp = false;
    }
  }
  return tmp;
}
function RetryOnErrorInterceptor(networkMonitor, retryStrategy) {
  networkMonitor = networkMonitor === VOID ? null : networkMonitor;
  retryStrategy = retryStrategy === VOID ? get_defaultRetryStrategy() : retryStrategy;
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return new (DefaultRetryOnErrorInterceptorImpl())(networkMonitor, retryStrategy);
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda($failFastIfOffline, this$0, $request, $downstream) {
  return constructCallableReference(function *($this$flow, $completion) {
    var tmp;
    var tmp_0;
    if ($failFastIfOffline) {
      var tmp0_safe_receiver = this$0.f63_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h63();
      tmp_0 = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n3()) === false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = yield* $this$flow.w1d(Builder().v41($request.t40_1, $request.u40_1).a42(ApolloOfflineException().p4d()).j37(), $completion);
    } else {
      tmp = yield* emitAll($this$flow, $downstream, $completion);
    }
    return Unit_instance;
  }, 1);
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_0($state, this$0) {
  return constructCallableReference(function *(it, $completion) {
    $state.b63_1 = it;
    var tmp;
    if (yield* this$0.g63_1.x62($state, $completion)) {
      var _receiver__tnumb7 = $state;
      _receiver__tnumb7.a63_1 = _receiver__tnumb7.a63_1 + 1 | 0;
      throw RetryException().k63();
    }
    return Unit_instance;
  }, 1);
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_1() {
  return constructCallableReference(function *($this$retryWhen, cause, _unused_var__etf5q3, $completion) {
    var tmp;
    if (cause instanceof RetryException()) {
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }, 3);
}
var DefaultRetryOnErrorInterceptorImplClass;
function DefaultRetryOnErrorInterceptorImpl() {
  if (DefaultRetryOnErrorInterceptorImplClass === VOID) {
    class $ {
      constructor(networkMonitor, retryStrategy) {
        this.f63_1 = networkMonitor;
        this.g63_1 = retryStrategy;
      }
      t62(request, chain) {
        var tmp0_elvis_lhs = request.i41_1;
        var failFastIfOffline = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
        var state = new (RetryContext())(this.f63_1, request);
        var downstream = chain.s62(request);
        var tmp = flow(DefaultRetryOnErrorInterceptorImpl$intercept$slambda(failFastIfOffline, this, request, downstream));
        var tmp_0 = onEach(tmp, DefaultRetryOnErrorInterceptorImpl$intercept$slambda_0(state, this));
        return retryWhen(tmp_0, DefaultRetryOnErrorInterceptorImpl$intercept$slambda_1());
      }
    }
    initMetadataForClass($, 'DefaultRetryOnErrorInterceptorImpl');
    DefaultRetryOnErrorInterceptorImplClass = $;
  }
  return DefaultRetryOnErrorInterceptorImplClass;
}
var RetryExceptionClass;
function RetryException() {
  if (RetryExceptionClass === VOID) {
    class $ extends Exception() {
      constructor() {
        return new.target.k63();
      }
      static k63() {
        var $this = this.xd('Retry');
        captureStack($this, $this.j63_1);
        return $this;
      }
    }
    initMetadataForClass($, 'RetryException', $.k63);
    RetryExceptionClass = $;
  }
  return RetryExceptionClass;
}
var sam$com_apollographql_apollo_interceptor_RetryStrategy$0Class;
function sam$com_apollographql_apollo_interceptor_RetryStrategy$0() {
  if (sam$com_apollographql_apollo_interceptor_RetryStrategy$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.l63_1 = function_0;
      }
      *x62(context, $completion) {
        return yield* this.l63_1(context, $completion);
      }
      i5() {
        return this.l63_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, RetryStrategy()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$com_apollographql_apollo_interceptor_RetryStrategy$0', VOID, VOID, [RetryStrategy(), FunctionAdapter()], [1]);
    sam$com_apollographql_apollo_interceptor_RetryStrategy$0Class = $;
  }
  return sam$com_apollographql_apollo_interceptor_RetryStrategy$0Class;
}
function defaultRetryStrategy$slambda() {
  return constructCallableReference(function *(state, $completion) {
    var request = state.z62_1;
    var exception = state.t5g().g42_1;
    var tmp;
    if (!(request.h41_1 === true) || exception == null) {
      return false;
    }
    var tmp_0;
    if (exception instanceof ApolloOfflineException()) {
      var tmp_1;
      var tmp_2 = request.t40_1;
      if (isInterface(tmp_2, Subscription())) {
        yield* waitForNetwork(ensureNotNull(state.y62_1), $completion);
        state.d63();
        return true;
      } else {
        return false;
      }
    }
    var tmp_3;
    if (isRecoverable(exception)) {
      var tmp_4;
      var tmp_5 = request.t40_1;
      if (!isInterface(tmp_5, Subscription())) {
        tmp_4 = state.e63() >= 3;
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        return false;
      }
      Companion_getInstance();
      // Inline function 'kotlin.math.pow' call
      var n = state.e63();
      var tmp$ret$0 = Math.pow(2.0, n);
      // Inline function 'kotlin.time.Companion.seconds' call
      var this_0 = coerceAtMost(tmp$ret$0, 60.0);
      var tmp$ret$1 = toDuration(this_0, DurationUnit_SECONDS_getInstance());
      yield* delay(tmp$ret$1, $completion);
      return true;
    }
    return false;
  }, 1);
}
var properties_initialized_RetryOnErrorInterceptor_kt_exnoek;
function _init_properties_RetryOnErrorInterceptor_kt__m47hbi() {
  if (!properties_initialized_RetryOnErrorInterceptor_kt_exnoek) {
    properties_initialized_RetryOnErrorInterceptor_kt_exnoek = true;
    var tmp = defaultRetryStrategy$slambda();
    defaultRetryStrategy = new (sam$com_apollographql_apollo_interceptor_RetryStrategy$0())(tmp);
  }
}
//region block: exports
export {
  RetryOnErrorInterceptor as RetryOnErrorInterceptor2wqvvqzzzk2ot,
};
//endregion

//# sourceMappingURL=RetryOnErrorInterceptor.mjs.map
